// Only keep a few high-frequency workbench-style list pages alive.
export const KEEP_ALIVE_ROUTE_NAMES = [
  'Inbox',
  'FollowUp',
  'Examine',
  'List',
  'MyFiles'
]

const keepAliveRouteNameSet = new Set(KEEP_ALIVE_ROUTE_NAMES)

export function shouldKeepAliveRoute(route) {
  const routeName = String(route?.name || '')
  return keepAliveRouteNameSet.has(routeName)
}
